<template>
  <div>
    <the-headersider />

    <!-- Toolbar -->
    <base-card class="toolbar">
  <div class="toolbar-left">
    <h2 class="title">Payment History</h2>
  </div>

  <div class="toolbar-center">
    <input
      type="search"
      v-model="search"
      class="search"
      placeholder="Search by name, account or reference"
    />
  </div>

  <div class="toolbar-right">
    <button class="csv-btn" @click="downloadCSV">
      ⬇ Download CSV
    </button>

    <router-link to="/receive/payment" class="cta">
      + Receive Payment
    </router-link>
  </div>
</base-card>



    <!-- Payments Table -->
    <base-card>
      <div class="table-wrapper">
        <table class="table table-bordered fancy-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Acc No</th>
              <th>Amount</th>
              <th>Payment Date</th>
              <th>Type</th>
              <th>Reference</th>
            </tr>
          </thead>

          <tbody>
            <tr v-if="filteredPayments.length === 0">
              <td colspan="6" class="empty">
                No payments found
              </td>
            </tr>

            <tr
              v-for="payment in filteredPayments"
              :key="payment.id"
            >
              <td class="name">{{ payment.paid_by }}</td>
              <td>{{ payment.clientId }}</td>

              <td class="amount">
                KES {{ formatAmount(payment.amount) }}
              </td>

              <td>
                {{ new Date(payment.payment_date).toLocaleString("en-GB") }}
              </td>

              <td>
                <span
            
                >
                  {{ payment.payment_type }}
                </span>
              </td>

              <td class="reference">
                {{ payment.payment_reference }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </base-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      search: "",
    };
  },

  computed: {
    payments() {
      return this.$store.getters.payments;
    },

    filteredPayments() {
      const key = this.search.toLowerCase();

      return this.payments
        .slice()
        .reverse()
        .filter(p =>
          (p.paid_by || "").toLowerCase().includes(key) ||
          String(p.clientId || "").includes(key) ||
          (p.payment_reference || "").toLowerCase().includes(key)
        );
    },
  },

  created() {
    this.$store.dispatch("LoadPayments");
  },

  methods: {
    formatAmount(amount) {
      return Number(amount).toLocaleString();
    },

    badgeClass(type) {
      if (!type) return "default";

      const t = type.toLowerCase();
      if (t.includes("mpesa")) return "mpesa";
      if (t.includes("bank")) return "bank";
      if (t.includes("cash")) return "cash";
      return "default";
    },

    downloadCSV() {
  if (!this.filteredPayments.length) {
    alert("No payments to download");
    return;
  }

  const headers = [
    "Name",
    "Account No",
    "Amount",
    "Payment Date",
    "Payment Type",
    "Reference",
  ];

  const rows = this.filteredPayments.map(p => {
    let date = "";
    if (p.payment_date) {
      const d = new Date(p.payment_date);
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      date = `${y}-${m}-${day}`;
    }

    return [
      p.paid_by || "",
      p.clientId || "",
      Number(p.amount || 0),
      date, // yyyy-mm-dd
      p.payment_type || "",
      p.payment_reference || "",
    ];
  });

  const csvContent = [
    headers.join(","),
    ...rows.map(row =>
      row
        .map(v => `"${String(v).replace(/"/g, '""')}"`)
        .join(",")
    ),
  ].join("\n");

  const blob = new Blob([csvContent], {
    type: "text/csv;charset=utf-8;",
  });

  const now = new Date();
  const fileName =
    "payments_" +
    now.getFullYear() +
    "-" +
    String(now.getMonth() + 1).padStart(2, "0") +
    "-" +
    String(now.getDate()).padStart(2, "0") +
    ".csv";

  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
},

  },
};
</script>


<style scoped>
/* Toolbar */
/* Toolbar layout */
.toolbar {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 1rem;
}

/* Sections */
.toolbar-left {
  display: flex;
  align-items: center;
}

.toolbar-center {
  display: flex;
}

.toolbar-right {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

/* Title */
.title {
  font-size: 1.3rem;
  font-weight: 700;
  color: #1f2937;
  white-space: nowrap;
}

/* Search */
.search {
  width: 100%;
  max-width: 360px;
  padding: 0.6rem 0.75rem;
  border-radius: 8px;
  border: 1px solid #d1d5db;
}

/* Download CSV */
.csv-btn {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  background: #16a34a;
  color: #fff;
  padding: 0.6rem 0.9rem;
  border-radius: 8px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  white-space: nowrap;
}

.csv-btn:hover {
  background: #15803d;
}

/* CTA */
.cta {
  background: #2563eb;
  color: #fff;
  padding: 0.6rem 1rem;
  border-radius: 8px;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
}

.cta:hover {
  background: #1d4ed8;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .toolbar {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }

  .toolbar-right {
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  .search {
    max-width: 100%;
  }
}

</style>
